/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import {
  Converter,
  ConverterService,
  EntitiesModel,
  Occ,
} from '@lm-nx-frontend/lm-inf-core';
import {BUDGET_NORMALIZER} from "../../core/connectors";
import {Budget} from "../../core/model";

@Injectable({
  providedIn: 'root',
})
export class OccBudgetListNormalizer
  implements Converter<Occ.BudgetsList, EntitiesModel<Budget>>
{
  constructor(private converter: ConverterService) {}

  convert(
    source: Occ.BudgetsList,
    target?: EntitiesModel<Budget>
  ): EntitiesModel<Budget> {
    if (target === undefined) {
      target = { ...(source as any) } as EntitiesModel<Budget>;
    }
    target.values =
      source.budgets?.map((budget) => ({
        ...this.converter.convert(budget, BUDGET_NORMALIZER),
      })) ?? [];
    return target;
  }
}
